var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          attrs: {
            accept:
              _vm.accept == "mp4"
                ? ".mp4, .avi, .wmv, .MP4, .AVI, .WMV, .swf, .mpeg, .mpg, .flv, .m3u8"
                : _vm.accept == "img"
                ? ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                : _vm.accept == "doc"
                ? ".pdf, .doc, .docx, .xls, .xlsx"
                : "" + _vm.accept,
            "before-upload": _vm.uploadBefore,
            "file-list": _vm.fileList,
            limit: 1,
            "on-remove": _vm.onRemove,
            action: "",
            drag: "",
          },
        },
        [
          _vm.fileList.length == 0
            ? [
                _c("i", { staticClass: "el-icon-upload" }),
                _c("div", { staticClass: "upload-import-text-main" }, [
                  _c("span", [_vm._v("点击上传或拖拽文件到这里进行上传")]),
                ]),
              ]
            : [
                _vm.accept == "doc"
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                          height: "100%",
                        },
                      },
                      [_vm._v("\n\t\t\t\t文档(暂无法预览)\n\t\t\t")]
                    )
                  : _vm._e(),
                _vm.accept == "img"
                  ? _c("el-image", {
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      },
                      attrs: { src: _vm.formData[_vm.prop] },
                    })
                  : _vm._e(),
                _vm.accept == "mp4"
                  ? _c("video", {
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      },
                      attrs: { src: _vm.formData[_vm.prop] },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.previewFlag = _vm.accept == "mp4"
                        },
                      },
                    })
                  : _vm._e(),
              ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            modal: false,
            visible: _vm.previewFlag,
            title: "预览视频",
            width: "50vw",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewFlag = $event
            },
          },
        },
        [
          _c("video", {
            staticStyle: { width: "100%", height: "50vh" },
            attrs: { src: _vm.formData[_vm.prop], controls: "" },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.previewFlag = false
                    },
                  },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }